import {
  LEGAL_PUBLICATION_STATUS,
  type LegalPublicationStatus,
} from '@tinkr/shared/legal'

export const LEGAL_SIGNUP_UNAVAILABLE_MESSAGE =
  'Provider signup is unavailable until current legal documents are published'

export function isLegalSignupBlocked(
  isProduction = import.meta.env.PROD,
  publicationStatus: LegalPublicationStatus = LEGAL_PUBLICATION_STATUS,
): boolean {
  return isProduction && publicationStatus !== 'published'
}
